
(function() {
  function initRelatedCarousel() {
    document.querySelectorAll('.related-products-carousel').forEach(root => {
      if (root.dataset.carouselInit) return;
      const track = root.querySelector('.carousel-track');
      if (!track) return;
      const slide = track.querySelector('li');
      const style = window.getComputedStyle(track);
      const gap   = parseFloat(style.gap) || 0;
      const slideWidth = slide.getBoundingClientRect().width + gap;
      const prev = root.querySelector('.carousel__button--prev');
      const next = root.querySelector('.carousel__button--next');
      if (prev) prev.addEventListener('click', () => {
        track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', () => {
        track.scrollBy({ left:  slideWidth, behavior: 'smooth' });
      });

      root.dataset.carouselInit = 'true';
    });
    yotpo.initWidgets()
  }

  document.addEventListener('DOMContentLoaded', initRelatedCarousel);
  window.addEventListener('load', initRelatedCarousel);

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches('.related-products-carousel') || node.querySelector('.related-products-carousel')) {
          initRelatedCarousel();
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

})();
